export const CHART_MARGIN = { top: 10, right: 50, bottom: 50, left: 70 }

export const CHART_LEFT_AXIS = {
  tickSize: 5,
  tickPadding: 5,
  tickRotation: 0,
  legendOffset: -60,
  legendPosition: 'middle',
}
export const CHART_BOTTOM_AXIS = {
  tickSize: 5,
  tickPadding: 5,
  tickRotation: 0,
  legendOffset: 46,
  legendPosition: 'middle',
}
